/**
 * Wohin nach der Anmeldung: das Ziel, von dem `RequireAuth` hierher umgeleitet hat, sonst die
 * Startseite. Nur ein Pfad innerhalb der Anwendung -- `//host` wäre für den Browser eine fremde
 * Adresse, und `/login` führte im Kreis.
 */
export function afterLoginTarget(state: unknown): string {
  const from = (state as { from?: unknown } | null)?.from;
  if (typeof from !== 'string' || !from.startsWith('/') || from.startsWith('//')) return '/';
  if (from === '/login' || from.startsWith('/login?')) return '/';
  return from;
}
